import React from "react";
import { Menu, MenuButton, MenuItem, MenuList, Portal } from "@chakra-ui/react";
import { sizes } from "../../settings/theme";
import { typedSxMap } from "../../utils/typedSxMap";
import { DialogItem, DialogProps } from "./types";
import { PiDotsThreeVerticalBold } from "react-icons/pi";

const styles = typedSxMap({
  menuList: {
    display: "flex",
    flexDirection: "column",
    gap: "2px",
    backgroundColor: "var(--color-background-menu)",
    borderRadius: "var(--border-radius-2)",
    boxShadow: "0 1px 4px rgba(black, 0.15)",
    border: "1px solid var(--color-border)",
    minWidth: "100px",
    padding: "var(--m-xxxxs)",
  },
  menuItem: {
    fontSize: "var(--font-size-xs)",
    padding: "calc(var(--m-xxs) + 0.5px) var(--m-s)",
    borderRadius: "var(--border-radius-2)",
    backgroundColor: "transparent",

    "&:hover, &.active": {
      backgroundColor: "var(--color-background-menu-hover)",
      borderRadius: "var(--border-radius-2)",
    },
    "&.active": { cursor: "default" },
  },
});

export default function Dialog({
  icon = <PiDotsThreeVerticalBold size={sizes.icon.large} />,
  variants = ["bare"],
  iconPosition = "right",
  items,
  dialogPosition = "right",
  useActiveAsLabel,
  ...props
}: DialogProps): React.ReactElement {
  const handleClick = (item: DialogItem) => (event: any) => {
    item?.action && item.action(item.id || null);
    item?.onClick && item.onClick((item.id || null) as any);
    event.stopPropagation();
  };

  return (
    <Menu>
      <MenuButton
        onClick={(event) => {
          event.stopPropagation();
        }}>
        {(useActiveAsLabel && items.find((item) => item.active)?.children) || props.children} {icon}
      </MenuButton>
      <Portal>
        <MenuList sx={styles.menuList}>
          {items.map((item, i) => {
            const { active } = item;
            return !active || !useActiveAsLabel ? (
              <MenuItem key={i} onClick={handleClick(item)} sx={styles.menuItem}>
                {item.children}
              </MenuItem>
            ) : null;
          })}
        </MenuList>
      </Portal>
    </Menu>
  );
}
